const QualityControl = {
    namespaced: true,
    state: {
        neqas: {
            tab: 0,
            period: null,
            filters: null,
            reports: null,
            currentReport: null,
        },
        horiba: {
            id: null,
            file: null,
            activate_on: null,
            expires_on: null,
        },
        blocked_device: {
            title: null,
            list: {},
            hasDeviceWithoutOperator: false,
            buttonText: null,
            hasContent: false,
            loading: true,
        },
        horiba_samples: {
            provider: null,
            loading: true,
            currentUserDevices: [],
        },
        errorMessages: {
            horiba: {
                id: [],
                file: [],
                activate_on: [],
                expires_on: [],
            },
        },
        my_devices: [],
    },
    getters: {},
    mutations: {
        SET_MY_DEVICE(state, devices) {
            _.set(state, 'my_devices', devices);
        },
        SET_NEQAS_TAB(state, tab) {
            state.neqas.tab = tab;
        },
        SET_HORIBA_SAMPLES_PROVIDER(state, provider) {
            _.set(state, 'horiba_samples.provider', provider);
        },
        SET_HORIBA_SAMPLES_PROVIDE_LOADING(state, loading) {
            _.set(state, 'horiba_samples.loading', loading);
        },
        SET_HORIBA_SAMPLES_CURRENT_USER_PROVIDES(state, currentUserDevices) {
            _.set(state, 'horiba_samples.currentUserDevices', currentUserDevices);
        },

        SET_BLOCKED_DEVICE_TITLE(state, title) {
            _.set(state, 'blocked_device.title', title);
        },
        SET_BLOCKED_DEVICE_LIST(state, data) {
            _.set(state, 'blocked_device.list', data);
        },
        SET_BLOCKED_DEVICE_BUTTON_TEXT(state, buttonText) {
            _.set(state, 'blocked_device.buttonText', buttonText);
        },
        SET_BLOCKED_DEVICE_NO_OPERATORS(state, hasDeviceWithoutOperator) {
            _.set(state, 'blocked_device.hasDeviceWithoutOperator', hasDeviceWithoutOperator);
        },
        SET_BLOCKED_DEVICE_HAS_CONTENT(state, hasContent) {
            _.set(state, 'blocked_device.hasContent', hasContent);
        },
        SET_BLOCKED_DEVICE_LOADING(state, loading) {
            _.set(state, 'blocked_device.loading', loading);
        },
        SET_NEQAS_REPORTS(state, reports) {
            state.neqas.reports = reports;
        },
        SET_NEQAS_CURRENT_REPORT(state, currentReport) {
            state.neqas.currentReport = currentReport;
        },
        SET_NEQAS_PERIOD(state, period) {
            state.neqas.period = period;
        },
        SET_NEQAS_FILTERS(state, filters) {
            state.neqas.filters = filters;
        },
        SET_HORIBA(state, horiba) {
            _.set(state, 'horiba', horiba);
        },
        SET_HORIBA_PROPERTY(state, data) {
            _.set(state, data.property, data.value);
        },
        SET_ERROR_MESSAGE(state, data) {
            _.set(state.errorMessages, data.property, data.value);
        },
        RESET_HORIBA_PROPERTY_ERROR(state, data) {
            _.set(state.errorMessages, data.property, data.value);
        },
    },
    actions: {
        fetchMyDevices({ commit }, userId) {
            return axios
                .get(
                    route('api.v1.quality-control.index', {
                        visible_in_qc_list: 1,
                        fields: 'id,is_patient_mode,operator.id',
                        limit: -1,
                        operator_id: userId,
                    })
                )
                .then((response) => {
                    const data = _.clone(response.data.data);
                    commit('SET_MY_DEVICE', data);
                });
        },
        fetchHoribaSamplesProvider({ commit }, provider) {
            commit('SET_HORIBA_SAMPLES_PROVIDE_LOADING', true);
            return axios
                .get(
                    route('api.v1.providers.show', {
                        blood_result_provider: provider,
                        fields: 'id,is_patient_mode,name,operator.id,operator.name',
                    })
                )
                .then((response) => {
                    const data = _.clone(response.data.data);
                    commit('SET_HORIBA_SAMPLES_PROVIDER', data);
                })
                .finally(() => {
                    commit('SET_HORIBA_SAMPLES_PROVIDE_LOADING', false);
                });
        },
        fetchHoribaSamplesCurrentUserProviders({ commit }, userId) {
            return axios
                .get(
                    route('api.v1.quality-control.index', {
                        operator_id: userId,
                        visible_in_qc_list: 1,
                        fields: 'id',
                    })
                )
                .then((response) => {
                    const currentUserDevices = _.clone(response.data.data);
                    commit('SET_HORIBA_SAMPLES_CURRENT_USER_PROVIDES', currentUserDevices);
                });
        },
        fetchBlockedDeviceList({ commit }) {
            return axios
                .get(route('api.v1.quality-control.blocked-devices'))
                .then((response) => {
                    commit('SET_BLOCKED_DEVICE_LOADING', true);
                    if (!response.data || response.data.length === 0) {
                        return;
                    }
                    let data = _.clone(response.data);
                    if (data.no_operator) {
                        commit('SET_BLOCKED_DEVICE_NO_OPERATORS', true);
                        const noOperator = new Object();
                        noOperator['No user'] = data.no_operator;
                        data = Object.assign(noOperator, data);
                        delete data.no_operator;
                    }
                    commit('SET_BLOCKED_DEVICE_HAS_CONTENT', true);
                    commit('SET_BLOCKED_DEVICE_LIST', data);
                })
                .finally(() => {
                    commit('SET_BLOCKED_DEVICE_LOADING', false);
                });
        },
        setBlockedDeviceTitle({ commit }, title) {
            commit('SET_BLOCKED_DEVICE_TITLE', title);
        },
        setBlockedDeviceButtonText({ commit }, buttonText) {
            commit('SET_BLOCKED_DEVICE_BUTTON_TEXT', buttonText);
        },
        fetchNeqasReprots({ commit }, data) {
            let params = _.clone(data);
            params.limit = params.limit || 18;
            params.page = params.page || 1;
            params.sort = '-created_at';
            params.fields = 'id,file_name';
            return axios
                .get(route('api.v1.neqas-reports.index'), {
                    params,
                })
                .then((response) => {
                    const reports = response.data;
                    commit('SET_NEQAS_REPORTS', reports);
                });
        },
        fetchNeqasCurrentReport({ commit }, report) {
            return axios
                .get(
                    route('api.v1.neqas-reports.show', {
                        neqas_report: report.id,
                    })
                )
                .then((response) => {
                    const report = response.data;
                    commit('SET_NEQAS_CURRENT_REPORT', report);
                });
        },
        clearCurrentReport({ commit }) {
            commit('SET_NEQAS_CURRENT_REPORT', null);
        },
        setNeqasTab({ commit }, tab) {
            commit('SET_NEQAS_TAB', tab);
        },
        setNeqasPeriod({ commit }, period) {
            commit('SET_NEQAS_PERIOD', period);
        },
        setNeqasFilters({ commit }, filters) {
            commit('SET_NEQAS_FILTERS', filters);
        },
        setHoriba({ commit }, horiba) {
            commit('SET_HORIBA', horiba);
        },
        updateProperty({ commit }, data) {
            commit('SET_HORIBA_PROPERTY', data);
        },
        resetErrorMessages({ commit, state }) {
            _.each(state.errorMessages, function (messages, field) {
                const vueObjectToPlain = JSON.parse(JSON.stringify(state.errorMessages[field]));
                if (_.isPlainObject(vueObjectToPlain)) {
                    _.each(state.errorMessages[field], function (messages, plainObjectField) {
                        commit('SET_ERROR_MESSAGE', { value: [], property: `${field}.${plainObjectField}` });
                    });
                } else {
                    commit('SET_ERROR_MESSAGE', { value: [], property: field });
                }
            });
        },
        setErrorMessages({ commit, state }, errors) {
            _.each(errors, function (fieldErrors) {
                const errorMessageField = _.get(state.errorMessages.pharmacy_site, fieldErrors.field);
                if (fieldErrors.field && errorMessageField !== undefined) {
                    commit('SET_ERROR_MESSAGE', {
                        value: fieldErrors.errors,
                        property: 'horiba.' + fieldErrors.field,
                    });
                }
            });
        },
        resetPropertyError({ commit }, data) {
            commit('RESET_HORIBA_PROPERTY_ERROR', data);
        },
    },
};
export default QualityControl;
